import React from 'react';

export function VideoLoadingProgress({
  progress,
}: {
  progress: number;
}): React.ReactElement | null {
  if (progress === null) return null;

  return (
    <div className="odin-absolute odin-top-0 odin-left-0 odin-right-0 odin-z-10 odin-h-1.5 odin-bg-white/20">
      <div
        className="odin-h-full odin-bg-purple-600 odin-transition-all odin-duration-500 odin-ease-out"
        style={{ width: `${progress}%` }}
      />
    </div>
  );
}
